import { useTranslation } from "react-i18next";
import React from "react";

function Mp3({ data }: any) {
  const { t } = useTranslation();
  const renderContent = () => {
    return <div className="center">{t("Câu hỏi tự luận", "Câu hỏi tự luận")}</div>;
  };

  return <div>{renderContent()}</div>;
}

export default Mp3;
